import React, { useState } from 'react';

const HealthAccordion = ({ title, healthy, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };
    return (
        <div className="health-accordion">
            <div
                className={`header ${healthy ? 'healthy' : 'unhealthy'}`}
                onClick={toggleOpen}
                aria-hidden="true">
                {title}
                <span className="icon">{isOpen ? '▲' : '▼'}</span>
            </div>
            <div className={`container ${isOpen ? 'open' : ''}`}>{children}</div>
        </div>
    );
};

export default HealthAccordion;
